<template>
  <footer class="row text-light pt-3 my-footer">
    <div class="col-md-8 pl-0">
      <div class="text-left">
        {{ $t(`homeFooter.addressOne`) }}
      </div>
      <div class="text-left">
        {{ $t(`homeFooter.branchAddress`) }}
      </div>
      <div class="text-left mb-2 mt-2" v-if="$i18n.locale == 'zh'">
        <svg-icon icon-class="Group" class-name="foot-svg"/>
        <span class="contract-icon ml-1">86 132 5731 1835</span>
      </div>
      <div class="text-left mt-2" v-else>
        <span class="contract-icon ml-1">Beijing EliteGo HR Services Co., Ltd.</span>
      </div>
      <div class="text-left mb-3">
        <ul class="nav">
          <li class="nav-item">
            <a
                class="nav-link pl-0 pr-2 py-0 d-flex align-items-end text-light text-decoration-none"
                href="https://www.linkedin.com/in/elitego-allot-354159367/recent-activity/all/"
                target="_blank"
            >
              <svg-icon icon-class="linkedin-icon" class-name="foot-svg"/>
              <span class="contract-icon ml-1">LinkedIn</span></a
            >
          </li>
          <li class="nav-item"><span class="nav-link px-0 py-0">|</span></li>
          <li class="nav-item">
            <a
                class="nav-link py-0 pl-2 d-flex align-items-end text-light text-decoration-none"
                href="https://x.com/ElitegoAllot"
                target="_blank"
            >
<!--              <svg-icon icon-class="facebook-icon" class-name="foot-svg"/>-->
              <span class="contract-icon ml-1">Twitter</span></a
            >
          </li>
        </ul>
      </div>
      <div class="text-left mb-3">
        Email: <a class="email_a" href="mailto:elitegoallot@elitegotalent.com">elitegoallot@elitegotalent.com</a>
      </div>
      <p class="text-left">
        {{ $t(`homeFooter.record`) }}
        <a
            style="text-decoration: none; color: #ffffff"
            href="https://beian.miit.gov.cn/"
            target="_blank"
        >
          京ICP备19045523号-3
        </a>
      </p>
    </div>
    <div class="col-md-4 d-flex justify-content-center">
      <div class="row footer-qrcode">
        <div class="col-6 d-flex flex-column align-items-center">
          <img src="@/assets/images/imgs/wx.png" alt=""/>
          <div class="footer-qrcode_contact rounded my-2 py-1">
            {{ $t(`homeFooter.contentOne`) }}
          </div>
        </div>
        <div class="col-6 d-flex flex-column align-items-center">
          <img src="@/assets/images/imgs/qrcode-wechat.png" alt=""/>
          <div
              class="footer-qrcode_wechat rounded my-2"
              v-if="$i18n.locale == 'en'"
          >
            {{ $t(`homeFooter.contentTwo`) }}
          </div>
          <div class="footer-qrcode_wechat1 rounded my-2" v-else>
            {{ $t(`homeFooter.contentTwo`) }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FooterIndex",
};
</script>
<style lang="scss" scoped>
$primaryColor: #17757a;
.my-footer {
  background-color: #050f19;
  font-size: 15px;
  padding: 0 6%;

  .foot-svg {
    color: #fff;
    font-size: 18px;
  }

  .nav-item {
    line-height: 18px;

    a {
      .contract-icon {
        border-bottom: 1px solid #fff;
        line-height: 20px;
      }
    }
  }
}

.email_a{
  color: #ffffff;
}

.footer-qrcode {
  user-select: none;
  max-width: 260px !important;
  font-size: 15px;

  img {
    width: 100px;
    height: 100px;
  }

  &_contact {
    width: 100px;
    height: 40px;
    background-color: $primaryColor;
    line-height: 32px;
    font-size: 15px;
  }

  &_wechat {
    width: 120px;
    height: 40px;
    background-color: $primaryColor;
    font-size: 14px;
  }

  &_wechat1 {
    width: 120px;
    height: 40px;
    background-color: $primaryColor;
    font-size: 14px;
    line-height: 40px;
  }
}
</style>
